import z from 'zod';

import { UserId } from '../BrandedIds';
import { zodJSInstantDate } from '../dates/BrandedDate';
import { zodBrandedUuid } from '../utils/Zod';

export const AuditLogHiddenData = z.object({
  hiddenBy: zodBrandedUuid<UserId>(),
  hiddenAt: zodJSInstantDate,
  comment: z.string(),
});
export type AuditLogHiddenData = z.infer<typeof AuditLogHiddenData>;
